function omitTextAndTabGroup(obj) {
  const { text: _, newTabGroup: __, ...rest } = obj;
  return rest;
}

export { omitTextAndTabGroup };
